/*
 * @Author: your name
 * @Date: 2020-08-05 20:54:25
 * @LastEditTime: 2021-03-17 16:57:59
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ksh-doctor/src/store/modules/live.js
 */
import * as types from '../mutation-types'
import mutation from '../mutation'
import {decodeText} from '@/utils/decodeText'
import * as LiveService from '../../service/LiveService'

const state = {
	liveMessageList:[],
	liveHistoryMsgList:[],
	systemMessageList:[],
	speakerMessageList:[],
	speakerHistoryMessageList:[],
	collectList:[],
	blackList:[],
	TimSdkHasReady:false,
	rewardHelpList:[],
	rewardMyHelpList:{},
}
const getters = {
    liveHistoryMsgList: () => [...state.liveHistoryMsgList].map(v=>{
        // let text = ''
        // if(v.type === 'TIMCustomElem') {
        //     const obj = JSON.parse(v.payload.data||"{}")
        //     text = obj.text
        // }else {
        // }
      if (v.type === 'TIMTextElem') {
         return {...v,text:decodeText(v.payload.text),name:v.nick||v.name}
      }
      return v

    }),
    liveMessageList: () => [...state.liveMessageList].map(v=>{
        let text = v.payload.text
        return {...v,text:decodeText(text)}
    }),
    barrageList:()=>[...state.liveMessageList].filter(v=>v.type==='TIMTextElem').map((k)=>{
        let time = 6
        let text = k.payload.text
        if(text>15){
            time = 3
        }
        return {
            id:k.ID,
            msg:text,
            time:time
        }
    }),
    speakerMessageList:()=>state.speakerMessageList,
    speakerHistoryMessageList:()=>state.speakerHistoryMessageList,
    collectList:()=>state.collectList,
    blackList:()=>state.blackList,
    TimSdkHasReady:()=>state.TimSdkHasReady,
    rewardHelpList:()=>state.rewardHelpList,
    rewardMyHelpList:()=>state.rewardMyHelpList,
}
const mutations ={
    [types.TIM_SDK_READY](state){
        state.TimSdkHasReady = true
    },
    [types.CLEAR_BARRAGE_LIST](state){
        state.barrageList = []
    },
    [types.ADD_BARRAGE_LIST](state,barrage){
        state.barrageList = [...state.barrageList,barrage]
    },
    [types.GET_SYSTEM_MESSAGE_LIST](state,list){
        state.systemMessageList = [...state.systemMessageList,...list]
    },
    [types.INIT_LIVE_HISTORY_MESSAGE_LIST](state,list){
        state.liveHistoryMsgList = []
    },
    [types.GET_LIVE_HISTORY_MESSAGE_LIST](state,list){
        state.liveHistoryMsgList = [...list,...state.liveHistoryMsgList]
    },
    [types.GET_LIVE_HISTORY_COMMENT_LIST](state,list){
        state.liveHistoryMsgList = [...state.liveHistoryMsgList,...list]
    },
    [types.INIT_LIVE_MESSAGE_LIST](state,list){
        state.liveMessageList = []
    },
    [types.GET_LIVE_MESSAGE_LIST](state,list){
        state.liveMessageList = [...state.liveMessageList,...list]
    },
    [types.SEND_LIVE_MESSAGE](state,item){
        state.liveMessageList = [...state.liveMessageList,item]
    },
    [types.UPDATE_LIVE_MESSAGE](state,item){
        let list = [...state.liveMessageList].map(v=>{
            if(v.sendId === item.sendId){
                v = item
            }
            return v
        })
        state.liveMessageList = [...list]
    },
    [types.DELETE_LIVE_MESSAGE](state,item){
        //同一条消息 发送者返回的消息id（末尾是-1） 和接受者的消息id不一样 （末尾是-0）
        // 因为有可能我发送的id是1，别人收到是0 别人删了 传过来是0 所以匹配不到 所以只匹配前面的
        let id = JSON.parse(item.payload.data).ID
        id = id.substring(0,id.length-1)
        state.liveMessageList = [...state.liveMessageList].filter(k=>k.ID.indexOf(id)<0)
    },
    [types.GET_SPEAKER_MESSAGE_LIST](state,list){
        state.speakerMessageList = [...state.speakerMessageList,...list]
    },
    [types.GET_HISTORY_SPEAKER_MESSAGE_LIST](state,list){
        state.speakerHistoryMessageList = [...list,...state.speakerHistoryMessageList]
    },
    [types.INIT_COLLECT_MESSAGE_LIST](state,list){
        state.collectList = [...list]
    },
    [types.GET_COLLECT_MESSAGE_LIST](state,list){
        state.collectList = [...state.collectList,...list]
    },
    [types.INIT_LIVE_BLACK_LIST](state,list){
        state.blackList = [...list]
    },
    [types.GET_LIVE_BLACK_LIST](state,list){
        state.blackList = [...state.blackList,...list]
    },
    [types.ADD_SPEAKER_MESSAGE_LIST](state,item){
        state.speakerMessageList = [...state.speakerMessageList,item]
    },
    [types.UPDATE_SPEAKER_MESSAGE](state,item){
        let list = [...state.speakerMessageList].map(v=>{
            if(v.sendId === item.sendId){
                v = item
            }
            return v
        })
        state.speakerMessageList = [...list]
    },
    [types.DEL_SPEAKER_MESSAGE_LIST](state,item){
        state.speakerMessageList = [...state.speakerMessageList].filter(k=>k.ID!=item.ID)
    },
    [types.DEL_COLLECT_MESSAGE](state,item){
        state.collectList = [...state.collectList].filter(k=>k.ID!=item.ID)
    },
    [types.DEL_BLACK_LIST](state,item){
        state.blackList = [...state.blackList].filter(k=>k.userId!=item.userId)
    },
    [types.DEL_CUSTOM_SPEAKER_MESSAGE_LIST](state,item){
        //同一条消息 发送者返回的消息id（末尾是-1） 和接受者的消息id不一样 （末尾是-0）
        // 因为有可能我发送的id是1，别人收到是0 别人删了 传过来是0 所以匹配不到 所以只匹配前面的
        let id = JSON.parse(item.payload.data).ID
        id = id.substring(0,id.length-1)
        state.speakerMessageList = [...state.speakerMessageList].filter(k=>k.ID.indexOf(id)<0)
    },
    [types.UPDATE_TOP_MESSAGE](state,item){
        state.speakerMessageList = [...state.speakerMessageList].map(k=>{
            if(k.ID==item.ID){
                k = item
            }
            return k
        })
		},
		[types.INIT_REWARD_HELP_LIST](state,res){
			state.rewardHelpList = res
		},
		[types.INIT_REWARD_MY_HELP_LIST](state,res){
			state.rewardMyHelpList = res
		},
    ...mutation
}
const actions={
    getHistoryMessageList({commit,state},data){
			commit(types.REQUEST_DOING)
			return LiveService.getLiveHistoryMessageList(data)
				.then(res=>{
					commit(types.REQUEST_CLOSE)
					commit(types.GET_HISTORY_SPEAKER_MESSAGE_LIST, res.data)
					return Promise.resolve(res)
				},rea=>{
					commit(types.REQUEST_CLOSE)
					return Promise.reject(rea)
				})
    },
    getCollectMessageList({commit,state},data){
			commit(types.REQUEST_DOING)
			return LiveService.getLiveHistoryMessageList(data)
				.then(res=>{
					commit(types.REQUEST_CLOSE)
					if(data.pageNo==1){
						commit(types.INIT_COLLECT_MESSAGE_LIST, res.data)
					}else{
						commit(types.GET_COLLECT_MESSAGE_LIST, res.data)
					}
					return Promise.resolve(res)
				},rea=>{
					commit(types.REQUEST_CLOSE)
					return Promise.reject(rea)
				})
    },
    getLiveBlackList({commit,state},data){
			commit(types.REQUEST_DOING)
			return LiveService.getBlackLiveList(data)
				.then(res=>{
					commit(types.REQUEST_CLOSE)
					if(data.pageNo==1){
						commit(types.INIT_LIVE_BLACK_LIST, res.data)
					}else{
						commit(types.GET_LIVE_BLACK_LIST, res.data)
					}
					return Promise.resolve(res)
				},rea=>{
					commit(types.REQUEST_CLOSE)
					return Promise.reject(rea)
				})
		},
		initRewardHelpList({commit,state},data){
			return LiveService.getHelpList(data)
			.then(res=>{
				commit(types.INIT_REWARD_HELP_LIST, res.data)
				return Promise.resolve(res)
			},rea=>{
				return Promise.reject(rea)
			})
		},
		initRewardMyHelpList({commit,state},data){
			return LiveService.getMyHelpList(data)
			.then(res=>{
				commit(types.INIT_REWARD_MY_HELP_LIST, res.data)
				return Promise.resolve(res)
			},rea=>{
				return Promise.reject(rea)
			})
		},
		onUnlockScene({commit,state},data){
			return LiveService.onUnlockScene(data)
			.then(res=>{
				return Promise.resolve(res)
			},rea=>{
				return Promise.reject(rea)
			})
		},
}
export default {
	state,
	getters,
	actions,
	mutations
}
